import Layout from "Components/Layout";
import React, { useState, useEffect } from "react";
import Styles from "./style.module.css";
import { CommonNotificationadd, getHighlights, deleteHighlight } from "Services/ServiceRequest";
import Swal from "sweetalert2";
import Loader from "Components/Loader/subload/loader";
import moment from "moment";
import { MdDelete } from "react-icons/md";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
function Page() {
    const [Active, setActive] = useState("msg_english");
    const [error_msg, setErrormsg] = useState(null);
    const [loading, setLoading] = useState(false);
    const [body, setBody] = useState({
        msg_english: { title: "", message: "" },
        msg_french: { title: "", message: "" },
        msg_spanish: { title: "", message: "" },
    });
    const [viewMode, setViewMode] = useState("list");
    const [highlights, setHighlights] = useState([]);

    const fetchHighlights = async () => {
        try {
            setLoading(true);
            const res = await getHighlights();
            if (res?.data?.Status === 1) {
                setHighlights(res.data.Highlights || []);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (viewMode === "list") {
            fetchHighlights();
        }
    }, [viewMode]);

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setLoading(true);
                    const res = await deleteHighlight(id);
                    if (res?.data?.Status === 1) {
                        Swal.fire(
                            "Deleted!",
                            "Highlight has been deleted.",
                            "success"
                        );
                        fetchHighlights();
                    }
                } catch (error) {
                    Swal.fire(
                        "Error!",
                        "Something went wrong while deleting.",
                        "error"
                    );
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    const Buttons = [
        { label: "English", value: "msg_english" },
        { label: "French", value: "msg_french" },
        { label: "Spanish", value: "msg_spanish" },
    ];
    const ChangeHandler = (value, key, language = Active) => {
        setBody((prev) => ({
            ...prev,
            [language]: { ...prev[language], [key]: value },
        }));
    };
    const validateForm = () => {
        // Check if any of the title fields are missing
        if (!body.msg_english.title) {
            return {
                Active: "msg_english",
                type: "title",
                message: "Title is required in English",
            };
        }
        // Check if any of the message fields are missing
        if (!body.msg_english.message) {
            return {
                Active: "msg_english",
                type: "message",
                message: "Message is required in English",
            };
        }
        if (!body.msg_french.title) {
            return {
                Active: "msg_french",
                type: "title",
                message: "Title is required in French",
            };
        }
        if (!body.msg_french.message) {
            return {
                Active: "msg_french",
                type: "message",
                message: "Message is required in French",
            };
        }
        if (!body.msg_spanish.title) {
            return {
                Active: "msg_spanish",
                type: "title",
                message: "Title is required in Spanish",
            };
        }

        if (!body.msg_spanish.message) {
            return {
                Active: "msg_spanish",
                type: "message",
                message: "Message is required in Spanish",
            };
        }

        // If all fields are valid, return null or an empty object
        return null;
    };
    const onSubmit = async (event) => {
        event.preventDefault();
        let Errors = validateForm();
        if (Errors) {
            setErrormsg(Errors);
            setActive(Errors?.Active);
            return;
        }
        try {
            setLoading(true);
            const response = await CommonNotificationadd(body);

            setLoading(false);
            setBody({
                msg_english: { title: "", message: "" },
                msg_french: { title: "", message: "" },
                msg_spanish: { title: "", message: "" },
            });
            setActive("msg_english");
            setErrormsg(null);
            if (response?.data?.Status === 1) {
                Swal.fire({
                    title: "Success",
                    text: "Notification Sent Successfully",
                    icon: "Success",
                });
            }
        } catch (err) {
            setLoading(false);
            console.log("err");
            Swal.fire({
                title: "Error",
                text: "Something went wrong please try again",
                icon: "error",
            });
        }
    };
    return (
        <Layout Active={"noti"}>
            {loading && <Loader />}
            <div className={`Main_container ${Styles["container"]}`}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3>Notification </h3>
                    <button
                        onClick={() => setViewMode(viewMode === "list" ? "add" : "list")}
                        style={{ padding: '8px 16px', cursor: 'pointer', borderRadius: '5px', border: '1px solid #ccc', background: '#fff' }}
                    >
                        {viewMode === "list" ? "Add Notification" : "Back to List"}
                    </button>
                </div>
                <div className="request_Tabs">
                    {Buttons.map((item) => (
                        <button
                            key={item.value}
                            className={Active == item.value ? "Active-tab" : ""}
                            onClick={() => setActive(item.value)}>
                            {item?.label}
                        </button>
                    ))}
                </div>
                {viewMode === "list" ? (
                    <div style={{ marginTop: '20px' }}>
                        {highlights.length === 0 && !loading ? (
                            <p>No notifications found.</p>
                        ) : (
                            highlights.map((item, index) => (
                                <div key={item.highlightId || index} style={{
                                    border: '1px solid #e5e7eb',
                                    padding: '20px',
                                    marginBottom: '16px',
                                    borderRadius: '12px',
                                    background: '#fff',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.02), 0 4px 12px rgba(0,0,0,0.04)',
                                    transition: 'all 0.2s ease-in-out',
                                }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.03), 0 10px 20px rgba(0,0,0,0.06)';
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.02), 0 4px 12px rgba(0,0,0,0.04)';
                                    }}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                            <h4 style={{ margin: '0', color: '#1f2937', fontSize: '1.2rem', fontWeight: 600, letterSpacing: '-0.01em' }}>{item[Active]?.title || 'No Title'}</h4>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#6b7280', fontSize: '0.9rem' }}>
                                                <span>{moment(item.createdAt).format("DD MMM YYYY, hh:mm A")}</span>
                                                {(item?.createdBy || item?.created_by) && (
                                                    <>
                                                        <span style={{ color: '#d1d5db' }}>•</span>
                                                        {/* <span>Sent by: <span style={{ fontWeight: 500, color: '#374151' }}>{item?.createdBy || item?.created_by}</span></span> */}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        <button
                                            onClick={() => handleDelete(item.highlightId)}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                color: '#ef4444',
                                                padding: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderRadius: '8px',
                                                transition: 'all 0.2s ease',
                                                opacity: 0.8
                                            }}
                                            onMouseOver={(e) => { e.currentTarget.style.background = '#fee2e2'; e.currentTarget.style.opacity = 1; }}
                                            onMouseOut={(e) => { e.currentTarget.style.background = 'none'; e.currentTarget.style.opacity = 0.8; }}
                                            title="Delete Highlight"
                                        >
                                            <MdDelete size={22} />
                                        </button>
                                    </div>
                                    <div style={{ background: '#f9fafb', padding: '15px', borderRadius: '8px', border: '1px solid #f3f4f6' }}>
                                        <div
                                            style={{ margin: '0', color: '#4b5563', lineHeight: '1.6', fontSize: '0.95rem' }}
                                            dangerouslySetInnerHTML={{ __html: item[Active]?.message || 'No Message' }}
                                        />
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                ) : (
                    <form onSubmit={onSubmit}>
                        <div className={Styles["form_control"]}>
                            <label htmlFor="">Title</label>
                            <input
                                type="text"
                                value={body[Active].title}
                                onChange={(e) =>
                                    ChangeHandler(e.target.value, "title", Active)
                                }
                            />
                        </div>
                        {error_msg &&
                            error_msg.type == "title" &&
                            error_msg.Active == Active && (
                                <span style={{ color: "red" }}>
                                    {error_msg?.message}
                                </span>
                            )}
                        <div className={Styles["form_control"]}>
                            <label htmlFor="">Message</label>
                            <ReactQuill
                                key={Active}
                                theme="snow"
                                value={body[Active].message}
                                onChange={(content) => ChangeHandler(content, "message", Active)}
                                className={Styles["quill_editor"]}
                            />
                        </div>
                        {error_msg &&
                            error_msg.type == "message" &&
                            error_msg.Active == Active && (
                                <span style={{ color: "red" }}>
                                    {error_msg?.message}
                                </span>
                            )}
                        <input type="submit" />
                    </form>
                )}
            </div>
        </Layout>
    );
}

export default Page;
